import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        // Evitar que el navegador restaure la posición de scroll tras recargar
        if ('scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual';
        }

        // Al cambiar de página, subir arriba del todo.
        // Lenis (smooth scroll) controla el scroll, así que hay que usar su API.
        if (window.lenisInstance) {
            window.lenisInstance.scrollTo(0, { immediate: true, force: true });
        } else {
            window.scrollTo(0, 0);
        }
    }, [pathname]);

    return null;
};

export default ScrollToTop;
